import Button from 'components/_UI/Button'
import Text from 'components/_UI/Text'
import React, { useState } from 'react'
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import interests from 'theme/interests'
import interestsApi from 'api/requests/interests'
import buttons from 'theme/buttons'
import sizes from 'theme/sizes'
import ButtonSelect from 'components/_UI/ButtonSelect'
import Loader from 'components/_UI/Loader'
import { useEffect } from 'react'

export default function Interest({ slug, setLoading }) {
    const [interest, setInterest] = useState(false)
    const [confirm, setConfirm] = useState(false)
    

    // useEffect(() => {
        
    // }, [])

    async function onConfirm(active) {
        try {
            setLoading(true)
            await interestsApi.toggle(slug, { status: interests.accept.id })
            setConfirm(true)
            setInterest(false)

        } catch (error) {
            console.log('error', error)
            setConfirm(false)
        } finally {
            setLoading(false)
        }
    }

    async function onInterest(active) {
        setLoading(true)
        try {
            await interestsApi.toggle(slug, { status: interests.interest.id })
            setInterest(true)
            setConfirm(false)
        } catch (error) {
            console.log('error', error)
            setInterest(false)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Column>
            <ContentContainer>
                <StyledButtonContainer>
                    <ButtonSelect 
                        isVariant={'pink-borded'}
                        onToggle={(state) => onConfirm(state)}
                        isActive={confirm}
                    >
                        {interests.accept.label} {`intrestssss${confirm}`}
                    </ButtonSelect>
                </StyledButtonContainer>

                <StyledButtonContainer>
                    <ButtonSelect 
                        isVariant={'yellow-borded'}
                        isActive={interest}
                        onToggle={(state) => onInterest(state)}
                    >
                        {interests.interest.label} {`intrestssss${interest}`}
                    </ButtonSelect>
                </StyledButtonContainer>
            </ContentContainer>
        </Column>
    )
}


const StyledButtonContainer = styled.div`
    width: 125px;
    margin-left: 8px;

    & > button {
        padding: 6px;
    }
`;

const ContentContainer = styled(Row)`
    width: 100%;
    align-items: center;
    justify-content: center;
`